// extracted by mini-css-extract-plugin
module.exports = {"socialIcons":"SocialIcons_socialIcons__JynbM","socialIconWrapper":"SocialIcons_socialIconWrapper__cWcIY","socialIcon":"SocialIcons_socialIcon__EogNk"};